import {
  createFileRoute,
  retainSearchParams,
  stripSearchParams,
} from '@tanstack/react-router'
import * as v from 'valibot'

import { companyDepartmentsQueries } from '@/http/api/companyDepartments'
import { userGroupQueries } from '@/http/api/usersGroups'
import { UserGroupDetailsMembers } from '@/user-groups/components/UserGroupDetails/UserGroupDetailsMembers/UserGroupDetailsMembers'

const defaultQueryValues = {
  member_states: [],
  member_department_id: '',
  member_license_provider_id: '',
}

const searchParamsSchema = v.object({
  member_states: v.optional(
    v.array(
      v.union([
        v.literal('active'),
        v.literal('pending'),
        v.literal('deactivated'),
      ]),
    ),
    defaultQueryValues.member_states,
  ),
  member_department_id: v.optional(
    v.string(),
    defaultQueryValues.member_department_id,
  ),
  member_license_provider_id: v.optional(
    v.string(),
    defaultQueryValues.member_license_provider_id,
  ),
})

export const Route = createFileRoute(
  '/company/_management/groups/$groupId/members',
)({
  component: RouteComponent,
  loaderDeps: ({
    search: { member_states, member_department_id, member_license_provider_id },
  }) => ({ member_states, member_department_id, member_license_provider_id }),
  loader: async ({ context: { queryClient }, params, deps }) => {
    queryClient.prefetchQuery(companyDepartmentsQueries.list())
    await queryClient.ensureQueryData(
      userGroupQueries.membersList(
        params.groupId,
        undefined,
        deps.member_states.length ? deps.member_states : undefined,
        deps.member_department_id || undefined,
        deps.member_license_provider_id || undefined,
      ),
    )
  },
  validateSearch: searchParamsSchema,
  search: {
    middlewares: [
      stripSearchParams(defaultQueryValues),
      retainSearchParams([
        'page',
        'size',
        'user_group_name',
        'sort_by',
        'sort_order',
        'creator_id',
        'creator_name',
        'from_created_at',
        'to_created_at',
        'private',
        'member_states',
        'member_department_id',
        'member_license_provider_id',
      ]),
    ],
  },
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { groupId } = Route.useParams()
  const { member_states, member_department_id, member_license_provider_id } =
    Route.useSearch()

  return (
    <UserGroupDetailsMembers
      groupId={groupId}
      statesFilter={member_states}
      onStatesFilterChange={(values) => {
        navigate({ search: (prev) => ({ ...prev, member_states: values }) })
      }}
      departmentId={member_department_id}
      onDepartmentIdChange={(id) => {
        navigate({
          search: (prev) => ({ ...prev, member_department_id: id }),
        })
      }}
      licenseProviderId={member_license_provider_id}
      onLicenseProviderChange={(id) => {
        navigate({
          search: (prev) => ({ ...prev, member_license_provider_id: id }),
        })
      }}
    />
  )
}
